import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Row from 'project/components/collaborator_row';
import {
  setActiveCollaborator, resend, updatePermission, setDeleteCollaborator, fetchHistory,
} from 'project/ducks/collaborators';

export function mapStateToProps({ project: { collaborators } }) {
  return {
    ...collaborators.data
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: setActiveCollaborator,
    fetchHistory,
    resend,
    updatePermission,
    startDelete: setDeleteCollaborator,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Row);



// WEBPACK FOOTER //
// ./project/containers/collaborator_row.js